import { Button } from '@cardboard-ui/react';
import { Trans } from '@lingui/macro';
import { ChevronDownIcon, ChevronUpIcon } from 'components/icons';
import React from 'react';

interface CollapseButtonProps {
  isOpen: boolean;
  onToggle(): void;
  width: number | string;
}

export const CollapseButton = ({
  onToggle,
  isOpen,
  width,
}: CollapseButtonProps) => {
  return (
    <Button
      zIndex="sticky"
      transition=".3s all"
      onClick={onToggle}
      pos="absolute"
      transform="rotate(-90deg)"
      transformOrigin="100% 100%"
      top={10}
      right={isOpen ? width : 0}
      size="xs"
      rightIcon={isOpen ? <ChevronDownIcon /> : <ChevronUpIcon />}
      borderBottomRadius={0}
    >
      <Trans
        context="document viewer sidebar label"
        comment="This is the label to hide and show the sidebar. Keep it short."
      >
        Details
      </Trans>
    </Button>
  );
};
